import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Routes } from './routes/Routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}  >
        <PersistGate loading={null} persistor={persistor}>
            <RouterProvider
                router={Routes}
                future={{
                    v7_relativeSplatPath: true,
                }}
            />
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
